// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://jdmfcaewsfyahrninmhy.supabase.co";
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpkbWZjYWV3c2Z5YWhybmlubWh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjg5OTU1NjgsImV4cCI6MjA0NDU3MTU2OH0.uZilYivTdcBOEi2S5HrHn0IF0DMXIFPFpyH8KtYRkpQ";

export const supabase = createClient(supabaseUrl, supabaseKey);